export const EMAIL_AUTH_VIEW = 'EMAIL';
export const PASSWORD_AUTH_VIEW = 'PASSWORD';
export const MESSAGE_AUTH_VIEW = 'MESSAGE';
export const CHILDREN_AUTH_VIEW = 'CHILDREN';
